import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { MoreOffers } from 'shared/components/BottomAuthorBlockNew';
import { selectOfferAgent } from 'shared/selectors';

export const AgentMoreOffersContainer: React.FC = () => {
  const agent = useSelector(selectOfferAgent, shallowEqual);

  if (!agent?.offersCount) {
    return null;
  }

  return <MoreOffers offersLink={agent.offersLink} offersCount={agent.offersCount} />;
};
